module.exports = __webpack_public_path__ + "static/media/NotoSansSC-Thin-Alphabetic.f2e20180.woff";